import { VehiclePayload, VehicleResponse } from "api/types";
import { AxiosError } from "axios";
import customAxios from "config";
import { globalJson } from "global/global_json";
import toast from "react-hot-toast";

export const getVehicleData = async (
  params: any
): Promise<{
  data?: VehicleResponse[];
  error?: string;
}> => {
  try {
    const response = await customAxios.get("/api/fleet/", {
      params: {
        company_id: globalJson.company_id,
        start_time: params.start_time,
        end_time: params.end_time,
      },
    });
    return { data: response.data };
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      return {
        error:
          error?.response?.data?.error ||
          "An error occurred while fetching fleet data.",
      };
    }
    return { error: "An unknown error occurred." };
  }
};

export const getAvailableVehicleData = async (
  params: VehiclePayload
): Promise<{ data?: VehicleResponse[] | null; error?: string }> => {
  try {
    const response = await customAxios.get("/api/fleet/", {
      params: {
        available: params.available,
        start_time: params.start_time,
        end_time: params.end_time,
        pickup_location: params.pickup_location,
        company_id: globalJson.company_id,
        booking_id: params.booking_id,
      },
    });
    return { data: response.data }; // Return response data if successful
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      toast.error(error.response.data.error);
    }
    return { error: "An unknown error occurred." };
  }
};

export const getUnavailableVehicleDataV2 = async (
  params: any,
  fleet_id: number,
  pickup_location_id?: number
): Promise<any> => {
  try {
    const response = await customAxios.get(
      `/api/fleet/${fleet_id}/unavailability-v2/`,
      {
        params: {
          start: params.start_date,
          end: params.end_date,
          location: pickup_location_id,
          booking_to_exclude: params.booking_to_exclude,
        },
      }
    );
    return { data: response.data }; // Return response data if successful
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      return {
        error:
          error?.response?.data?.error ||
          "An error occurred while fetching fleet data.",
      };
    }
    return { error: "An unknown error occurred." };
  }
};
